enum EventCategoryEnum {
  'Evento especial' = 'blue',
  'Torneo' = 'yellow',
  'Watchparty' = 'fucsia',
  'Festival' = 'aqua',
  'Conferencia' = 'orange',
  'Lanzamiento' = 'limegreen',
  'Concierto' = 'red',
  'Comunitario' = 'green',
}

export default EventCategoryEnum;